import type { Completude } from '../../services/efetivosService';

/** As contas e os textos da completude (#606), comuns à barra, às linhas e às janelas. */
export type FaixaDaCompletude = 'baixa' | 'media' | 'alta' | 'completa';

export function faixaDaCompletude(porcentagem: number): FaixaDaCompletude {
  if (porcentagem >= 100) return 'completa';
  if (porcentagem >= 80) return 'alta';
  if (porcentagem >= 40) return 'media';
  return 'baixa';
}

/** Arredonda para baixo: 99,5% ainda não é completo. */
export function porcentagemDe({ preenchidas, total }: Completude): number {
  return total > 0 ? Math.floor((preenchidas / total) * 100) : 0;
}

/** "12 de 20 informações preenchidas". */
export function contagemDaCompletude({ preenchidas, total }: Completude): string {
  return `${preenchidas} de ${total} ${total === 1 ? 'informação preenchida' : 'informações preenchidas'}`;
}

function eCompletude(valor: unknown): valor is Completude {
  if (typeof valor !== 'object' || valor === null) return false;
  const { preenchidas, total, faltam } = valor as Record<string, unknown>;
  return (
    typeof preenchidas === 'number' &&
    typeof total === 'number' &&
    Array.isArray(faltam) &&
    faltam.every((item) => typeof item === 'string')
  );
}

/** A completude que o servidor mandou na aplicação, ou nada quando ele não manda (servidor antigo). */
export function completudeDe(aplicacao: unknown): Completude | undefined {
  if (typeof aplicacao !== 'object' || aplicacao === null || !('completude' in aplicacao)) return undefined;
  const valor: unknown = aplicacao.completude;
  return eCompletude(valor) ? valor : undefined;
}

/** O link da linha diz o que a janela faz: completar enquanto falta algo, editar quando não. */
export function rotuloDaJanela(completude: Completude | undefined): 'Completar dados' | 'Editar dados' {
  return completude && completude.total > 0 && completude.preenchidas < completude.total ? 'Completar dados' : 'Editar dados';
}
